import { css } from '@emotion/core';

export const markdownListStyles = css`
	ul,
	ol {
		padding-inline-start: 40px;
		padding-left: 1.38889em;
		margin-left: -0.27778em;
	}

	> ul,
	> ol {
		margin-block-start: 1em;
		margin-block-end: 1em;
	}

	ul {
		list-style: disc;
	}

	ul ul {
		list-style: circle;
	}

	ul ul ul {
		list-style: square;
	}

	ol {
		list-style: decimal;
	}

	ol ol {
		list-style: lower-alpha;
	}

	ol ol ol {
		list-style: lower-roman;
	}
`;
